import { SurveyDistributionQueueComponent } from './components/survey-distribution-queue/survey-distribution-queue.component';
import { SafeHtmlPipe } from './pipes/SafeHtml.pipe';
import { LogoutComponent } from './components/logout/logout.component';
import { BaseComponent } from './components/base/base.component';
import { PageCountArray } from './pipes/PageCountArray.pipe';
import { TruncatePipe } from './pipes/Truncate.pipe';
import { PreventKeyseDirective } from './directives/prevent-keys.directive';
import { AppToastOptions } from './classes/AppToastOptions';
import { LSServerService } from './services/LSServer.service';
import { LSAppService } from './services/LSApp.service';
import { LSApiService } from './services/LSApi.service';
import { AlertService } from './services/Alert.service';
import { WindowRefService } from './services/WindowRef.service';
import { CategoriesQuickActionsComponent } from './components/categories-quick-actions/categories-quick-actions.component';
import { SubCategoryNeComponent } from './components/sub-category-ne/sub-category-ne.component';
import { CategoryNeComponent } from './components/category-ne/category-ne.component';
import { SubCategoriesComponent } from './components/sub-categories/sub-categories.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { DistributedSurveyViewComponent } from './components/distributed-survey-view/distributed-survey-view.component';
import { SurveyQuestionsNeComponent } from './components/survey-questions-ne/survey-questions-ne.component';
import { DistributedSurveyNewComponent } from './components/distributed-survey-new/distributed-survey-new.component';
import { DistributedSurveysComponent } from './components/distributed-surveys/distributed-surveys.component';
import { SurveyManagementComponent } from './components/survey-management/survey-management.component';
import { OrganizationEmployeeNeComponent } from './components/organization-employee-ne/organization-employee-ne.component';
import { OrganizationDepartmentNeComponent } from './components/organization-department-ne/organization-department-ne.component';
import { OrganizationManagementComponent } from './components/organization-management/organization-management.component';
import { SurveysQuickActionsComponent } from './components/surveys-quick-actions/surveys-quick-actions.component';
import { OrganizationQuickActionsComponent } from './components/organization-quick-actions/organization-quick-actions.component';
import { OrganizationNeComponent } from './components/organization-ne/organization-ne.component';
import { SurveysComponent } from './components/surveys/surveys.component';
import { OrganizationsComponent } from './components/organizations/organizations.component';
import { DefaultComponent } from './components/default/default.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './components/app/app.component';
import { HomeComponent } from './components/home/home.component';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportsQuickActionsComponent } from './components/reports-quick-actions/reports-quick-actions.component';
import { ReportNewComponent } from './components/report-new/report-new.component';
import { OrganizationManagementQuickActionsComponent } from './components/organization-management-quick-actions/organization-management-quick-actions.component';
import { UploadExcelComponent } from './components/upload-excel/upload-excel.component';
import { OrganizationEmployeesComponent } from './components/organization-employees/organization-employees.component';
import { SurveyNeComponent } from './components/survey-ne/survey-ne.component';
import { SurveyManagementQuickActionsComponent } from './components/survey-management-quick-actions/survey-management-quick-actions.component';
import { SubCategoriesQuickActionsComponent } from './components/sub-categories-quick-actions/sub-categories-quick-actions.component';
import {BusyModule} from 'angular2-busy';
import { ProgressHttpModule } from "angular-progress-http";
import {ToastModule, ToastOptions} from 'ng2-toastr/ng2-toastr';
import { LightboxModule } from 'angular2-lightbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EmailQueueComponent } from './components/email-queue/email-queue.component';
import { CorporateReportComponent } from './components/corporate-report/corporate-report.component';
import { DemoUsersComponent } from './components/demo-users/demo-users.component';
import { DemoUsersQuickActionsComponent } from './components/demo-users-quick-actions/demo-users-quick-actions.component';
import { CorporateReportAttributeComponent } from './components/corporate-report-attribute/corporate-report-attribute.component';


@NgModule({
    declarations: [
        PreventKeyseDirective,
        TruncatePipe,
        SafeHtmlPipe,
        PageCountArray,

        BaseComponent,

        LogoutComponent,

        AppComponent,
        HeaderComponent,
        FooterComponent,
        DefaultComponent,
        HomeComponent,
        LoginComponent,
        OrganizationsComponent,
        SurveysComponent,
        DistributedSurveysComponent,
        OrganizationNeComponent,
        OrganizationQuickActionsComponent,
        OrganizationManagementComponent,
        OrganizationManagementQuickActionsComponent,
        SurveysQuickActionsComponent,
        ReportsComponent,
        ReportsQuickActionsComponent,
        ReportNewComponent,
        UploadExcelComponent,
        OrganizationDepartmentNeComponent,
        OrganizationEmployeeNeComponent,
        OrganizationEmployeesComponent,
        SurveyNeComponent,
        SurveyManagementComponent,
        SurveyManagementQuickActionsComponent,
        DistributedSurveyNewComponent,
        SurveyQuestionsNeComponent,
        DistributedSurveyViewComponent,
        CategoriesComponent,
        SubCategoriesComponent,
        SubCategoryNeComponent,
        CategoryNeComponent,
        CategoriesQuickActionsComponent,
        SubCategoriesQuickActionsComponent,
        EmailQueueComponent,
        SurveyDistributionQueueComponent,
        CorporateReportComponent,
        DemoUsersComponent,
        DemoUsersQuickActionsComponent,
        CorporateReportAttributeComponent
        
    ],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        BusyModule,
        LightboxModule,
        ToastModule.forRoot(),
        HttpModule,
        ProgressHttpModule,
        FormsModule,
        RouterModule.forRoot([
            { path: '', redirectTo: 'default', pathMatch: 'full' },
            { path: 'default', component: DefaultComponent },
            { path: 'admin', redirectTo: 'admin/login', pathMatch: 'full' },
            { path: 'admin/home', component: HomeComponent },
            { path: 'admin/login', component: LoginComponent },
            { path: 'admin/organizations', component: OrganizationsComponent },
            { path: 'admin/categories', component: CategoriesComponent },
            { path: 'admin/sub-categories', component: SubCategoriesComponent },
            { path: 'admin/surveys', component: SurveysComponent },
            { path: 'admin/reports', component: ReportsComponent },
            { path: 'admin/corporate-report', component: CorporateReportComponent },
            { path: 'admin/corporate-report-attribute', component: CorporateReportAttributeComponent },
            { path: 'admin/email-queue', component: EmailQueueComponent },
            { path: 'admin/survey-distribution-queue', component: SurveyDistributionQueueComponent },

            
            { path: 'admin/organizations/upload-excel', component: UploadExcelComponent },
            { path: 'admin/organizations/new', component: OrganizationNeComponent },
            { path: 'admin/organizations/:orgId/edit', component: OrganizationNeComponent },
            { path: 'admin/organizations/:orgId/manage', component: OrganizationManagementComponent },
            { path: 'admin/organizations/:orgId/departments', component: OrganizationManagementComponent },
            { path: 'admin/organizations/:orgId/departments/new', component: OrganizationDepartmentNeComponent },
            { path: 'admin/organizations/:orgId/departments/:deptId/edit', component: OrganizationDepartmentNeComponent },
            { path: 'admin/organizations/:orgId/employees', component: OrganizationEmployeesComponent },
            { path: 'admin/organizations/:orgId/employees/new', component: OrganizationEmployeeNeComponent },
            { path: 'admin/organizations/:orgId/employees/:empId/edit', component: OrganizationEmployeeNeComponent },
            
            { path: 'admin/categories/new', component: CategoryNeComponent },
            { path: 'admin/categories/:catId/edit', component: CategoryNeComponent },
            
            { path: 'admin/sub-categories/new', component: SubCategoryNeComponent },
            { path: 'admin/sub-categories/:subcatId/edit', component: SubCategoryNeComponent },
            
            
            { path: 'admin/surveys/new', component: SurveyNeComponent },
            { path: 'admin/surveys/:surveyId/edit', component: SurveyNeComponent },
            { path: 'admin/surveys/:surveyId/manage', component: SurveyManagementComponent },
            { path: 'admin/surveys/:surveyId/questions', component: SurveyManagementComponent },
            { path: 'admin/surveys/:surveyId/questions/new', component: SurveyQuestionsNeComponent },
            { path: 'admin/surveys/:surveyId/questions/:qId/edit', component: SurveyQuestionsNeComponent },
            { path: 'admin/surveys/:surveyId/distributed', component: DistributedSurveysComponent },
            { path: 'admin/surveys/:surveyId/distributed/new', component: DistributedSurveyNewComponent },
            { path: 'admin/surveys/:surveyId/distributed/:dId/view', component: DistributedSurveyViewComponent },

            { path: 'admin/reports/new', component: ReportNewComponent },

            { path: 'admin/demo-users', component: DemoUsersComponent },

            { path: 'admin/logout', component: LogoutComponent },

            { path: '**', redirectTo: 'default' }
        ])
    ],
    providers: [ {provide: ToastOptions, useClass: AppToastOptions}, WindowRefService, AlertService, LSApiService, LSAppService, LSServerService ]
})
export class AppModuleShared {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/app.module.shared.ts